import { useResponsive } from '@hook/useResponsive';
import { createContext, useContext, useEffect, useState } from 'react';

const LayoutSettingContext = createContext({
  isMini: false,
  handleClickSidebarModeToggle: () => {},
});

export function LayoutSettingContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isMobile } = useResponsive();
  const [isMini, setIsMini] = useState<boolean>(false);

  const handleClickSidebarModeToggle = () => {
    setIsMini(!isMini);
  };

  useEffect(() => {
    if (isMobile) {
      setIsMini(true);
    } else {
      setIsMini(false);
    }
  }, [isMobile]);

  return (
    <LayoutSettingContext.Provider
      value={{
        isMini,
        handleClickSidebarModeToggle,
      }}
    >
      {children}
    </LayoutSettingContext.Provider>
  );
}

export function useLayoutSettingContext() {
  return useContext(LayoutSettingContext);
}
